module.exports = __webpack_public_path__ + "img/1 (93).9f2677b2.png";